/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ArrowBigDown = [
  "svg",
  defaultAttributes,
  [["path", { d: "M15 6v6h4l-7 7-7-7h4V6h6z" }]]
];

export { ArrowBigDown as default };
//# sourceMappingURL=arrow-big-down.js.map
